module.exports = __webpack_public_path__ + "img/mathmaster.89562540.png";